import { useBackend } from "../../services";

export const useCreateMercadoPagoPurchase = () => {
  const { post } = useBackend();
  const createMercadoPagoPurchase = async (parameters: ICreateMercadoPagoPurchaseParameters) => {
    return post("mercadopago/purchase", parameters);
  };
  return { createMercadoPagoPurchase };
};

export interface ICreateMercadoPagoPurchaseParameters {
  paymentId: string;
}
